import { ArrowLeftOutlined } from "@ant-design/icons";
import { Box, Stack, Typography } from "@mui/material";
import { ReportDto } from "interfaces/report";
import { useNavigate, useParams } from "react-router-dom";

interface Props {
  report: ReportDto;
}

export default function HeaderAction({ report }: Props) {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <Stack spacing={1} direction="row" alignItems="center">
      <Box
        onClick={() => navigate(`/reports/${params.id}/detail`)}
        style={{ cursor: "pointer" }}
      >
        <ArrowLeftOutlined />
      </Box>
      <Typography variant="h3">Revision summary for {report.name}</Typography>
    </Stack>
  );
}
